import {API_URL, handleErrorResponse} from "../utility/utility";

export async function findCouponUsagesWithPagination(page, limit, couponId = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (couponId) {
        params.append('couponId', couponId);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/coupon-usages?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch coupon usages');

    return response.json();
}
